import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'
import { SelectAccount } from '../pages/SelectAccount'

/** `/select-account` inside the router (MS-977). The account choice runs on
 * the pending-login cookie only; a signed-in user who opens it directly (a
 * bookmark, history) has none, so GET /accounts would 401 and SelectAccount
 * would sign them out as "expired" while their session cookie is still
 * valid. Like LoginRoute, a live session goes Home instead. */
export function SelectAccountRoute() {
  const { status } = useAuth()
  if (status === 'authenticated') return <Navigate to="/" replace />
  return <SelectAccount />
}
